import { Button, Dropdown, Form, MenuProps } from 'antd';
import React, { useMemo } from 'react';
import { useRestContext } from '../RestInputContext';
import { DropdownStyle } from './styles';
import { get } from 'lodash';

export default function HighlightDropDown({ src, highlightName, setIsFocus }) {
  const { form } = useRestContext();
  const setHighlight = () => {
    form.setFieldValue(
      highlightName,
      form.getFieldValue(highlightName) === src ? null : src,
    );
  };

  const onOpenChange = (e) => {
    setIsFocus(e);
  };

  const menuItems: MenuProps = useMemo(() => {
    return {
      items: [
        {
          className: 'p-0 m-0',
          label: (
            <Form.Item
              noStyle
              shouldUpdate={(o, n) =>
                get(o, highlightName) !== get(n, highlightName)
              }
            >
              {({ getFieldValue }) => (
                <Button
                  type={
                    getFieldValue(highlightName) === src ? 'primary' : 'text'
                  }
                  onClick={setHighlight}
                  className="w-full"
                >
                  Main
                </Button>
              )}
            </Form.Item>
          ),
          type: 'group',
        },
      ],
    };
  }, [form, highlightName]);

  return (
    <Dropdown
      className="w-full"
      onOpenChange={onOpenChange}
      trigger={['click']}
      menu={menuItems}
      dropdownRender={(menu) => (
        <DropdownStyle>
          {React.cloneElement(menu as React.ReactElement, {
            style: { margin: 0, padding: 0 },
          })}
        </DropdownStyle>
      )}
    >
      <Button className="w-full">Set</Button>
    </Dropdown>
  );
}
